/** @jsx CanvaSX */
import type TextField from '../../../fields/TextField';
import { CanvaSX } from '@lib/canvasx/canvasx';
import { Text } from '@lib/canvasx/components/Text';
import { type FieldCanvaSXFactory } from './types';
import { Rect } from '@lib/canvasx/components/Rect';

export const TextFieldCanvaSX: FieldCanvaSXFactory = (
  field: TextField,
  object,
  value,
  maxChildWidth
) => {
  if (value) {
    return (
      <Rect padding={{ vertical: 2 }}>
        <Text size={8} maxWidth={maxChildWidth} overflow='…'>
          {value}
        </Text>
      </Rect>
    );
  }
};
